import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BounakirFilterType } from "../../../../helpers/Enums";
import { RootState } from "../../../../redux/store";
import {
  deleteMemberFootPrint,
  getBounakirMembers,
  getMemberPremiumStatus,
} from "../../../../services/memberService";
import { MemberCarpet } from "../../../../typings/member";
import FilterDropdown from "../FilterDropdown";
import BounakirCarpetLoader from "../BounakirCarpetLoader";
import EmptyCarpetPlaceHolder from "../../../../components/EmptyCarpetPlaceHolder";
import BounakirItem from "../BounakirItem";
import {
  setBounkairCarpetFilterCategory,
  setNeedToRefresh,
} from "../../../../redux/carpet";
import InfiniteScroll from "react-infinite-scroll-component";
import BounakirMenu from "../../BounakirMenu";
import { NavLink } from "react-router-dom";
import { HOMEPAGE } from "../../../../navigation/Constants";
import { getVisableWatchedMeForFreemium } from "../../../../services/appSettingService";
import { log } from "console";
import { ConsoleLogger } from "@microsoft/signalr/dist/esm/Utils";

const BounakirWatchMeCarpet = () => {
  const dispatch = useDispatch();
  const [membersCarpet, setMembersCarpet] = useState<MemberCarpet[] | null>(
    null
  );
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [canShowMembersProfilePciture, setCanShowMembersProfilePciture] =
    useState<boolean>(false);
  const { memberCode: myMemberCode } = useSelector(
    (state: RootState) => state.member
  );
  const { bounakirFilterCategory: selected } = useSelector(
    (state: RootState) => state.carpet
  );
  const { needToRefresh } = useSelector((state: RootState) => state.carpet);
  const [watchedMeLimitFreemium, setWatchedMeLimitFreemium] = useState<
    number | null
  >(null);
  const [hasMoreData, setHasMoreData] = useState<boolean>(false);
  const [nextPageNumber, setNextPageNumber] = useState<number>(1);

  useEffect(() => {
    getMemberStatus();
    console.log("BounakirWatchMeCarpet selected: ", selected);
  }, []);

  // useEffect(() => {
  //   setMembersCarpet(null);
  //   setIsLoading(true);
  // }, [selected]);

  // useEffect(() => {
  //   console.log({ selected });
  // }, [selected]);

  // useEffect(() => {
  //     if (selected.value != BounakirFilterType.BOUNAKIR_NEMU) {
  //         window.scrollTo(0, 0);
  //         getUsers(1);
  //     }
  // }, [selected])

  // useEffect(() => {
  //     if (needToRefresh) {
  //         getUsers(1);
  //         dispatch(setNeedToRefresh(false));
  //         window.scrollTo(0, 0);
  //     }
  // }, [needToRefresh])

  useEffect(() => {
    getUsers(1);
    dispatch(setNeedToRefresh(false));
    window.scrollTo(0, 0);

    // dispatch(
    //   setBounkairCarpetFilterCategory({
    //     value: BounakirFilterType.WATCHE_ME,
    //     text: "היכרויות",
    //   })
    // );
  }, []);

  const getUsers = async (page: number): Promise<any> => {
    const {
      data: { items, links },
    }: any = await getBounakirMembers(
      myMemberCode,
      BounakirFilterType.WATCHE_ME,
      // BounakirFilterType.DOUBLE_MATCH,
      page
    );
    setMembersCarpet(items);

    // if (links)
    //     handleHasMoreData(links);
    setIsLoading(false);
  };

  const getMemberStatus = async () => {
    try {
      const { data: isAllowedFeature }: any = await getMemberPremiumStatus(1);

      if (!isAllowedFeature) {
        const { data: numOfFreemium }: any =
          await getVisableWatchedMeForFreemium();
        setWatchedMeLimitFreemium(numOfFreemium);
      }
      console.log({ isAllowedFeature });
      setCanShowMembersProfilePciture(isAllowedFeature);
    } catch (ex) {}
  };
  // const fetchingMorData = async () => {
  //     const members = await getUsers(nextPageNumber);
  //     setMembersCarpet(carpets => [...carpets, ...members]);
  // };

  // const handleHasMoreData = (links: any) => {
  //     if (links.Next) {
  //         setNextPageNumber(count => count + 1);
  //         setHasMoreData(true);
  //     } else {
  //         setNextPageNumber(-1);
  //         setHasMoreData(false);
  //     }
  // };

  const generateTitle = () => {
    if (selected.value === BounakirFilterType.DOUBLE_MATCH)
      return "עדיין אין לך היכרויות";
    if (selected.value === BounakirFilterType.SENT_ME_BOUNAKIR)
      return "כאן יופיעו הצעות היכרות שקיבלת";
    if (selected.value === BounakirFilterType.SENT_THEM_BOUNAKIR)
      return "כאן יופיעו האנשים ששלחת להם הצעת היכרות";
    if (selected.value === BounakirFilterType.WATCHE_ME)
      return "כאן אפשר לראות מי ביקרו בפרופיל שלך";
    return "";
  };

  const generateSubTitle = () => {
    if (selected.value === BounakirFilterType.DOUBLE_MATCH)
      return "היכרות בשושק'ה נוצרת כשאחד הצדדים שולח הצעת היכרות,  והצד השני מאשר אותה";
    if (selected.value === BounakirFilterType.SENT_ME_BOUNAKIR)
      return "אלה ההצעות שאחרים שלחו לך";
    if (selected.value === BounakirFilterType.SENT_THEM_BOUNAKIR)
      return "ברגע שהם יאשרו את ההצעה אפשר יהיה להתחיל להתכתב!";
    if (selected.value === BounakirFilterType.WATCHE_ME)
      return "אולי זו תחילתה של חברות מופלאה...";
    return "";
  };

  const deleteFootPrint = async (memberCode: number) => {
    const res = await deleteMemberFootPrint(memberCode);
    if (res.status === 204) {
      const updatedList =
        membersCarpet?.filter((member) => member.memberCode !== memberCode) ||
        [];

      console.log("cccc");

      setMembersCarpet(updatedList);
    } else {
      //show error that happend
    }
  };

  const canMemberWatchProfile = (index: number) => {
    if (!canShowMembersProfilePciture) {
      if (watchedMeLimitFreemium !== null && watchedMeLimitFreemium > index) {
        console.log("22222");
        return true;
      } else {
        console.log("33333");
        return false;
      }
    }
    return true;
  };

  const rejectBounakirMemberSend = () => {};

  const rejectBounakirMemberRecived = () => {};

  useEffect(() => {
    // console.log({ membersCarpet });
    console.log("BounakirWatchMeCarpet membersCarpet: ", membersCarpet);
  }, [membersCarpet]);

  return (
    <>
      {/* <div className="top_sec desk wf-section">
                <NavLink className="top_logo_bounakir w-inline-block" to={HOMEPAGE}>
                    <img src="assets/images/shoshke_logo.svg" loading="lazy" />
                </NavLink>
                <div className="top_content">
                    <FilterDropdown />
                </div>
            </div> */}

      {/* <div className="top_sec wf-section"> */}
      <div className="top_sec desk">
        <NavLink className="top_logo_bounakir w-inline-block" to={HOMEPAGE}>
          <img
            src="assets/images/shoshke_logo.svg"
            loading="lazy"
            alt="shoshke logo"
          />
        </NavLink>
        {/* <div className="top_content messages w-clearfix">
          <h1
            className="top_title messages"
            // style={{ position: "relative", left: "48px" }}
          >
            ביקרו בפרופיל שלי
          </h1>
        </div> */}

        <div className="top_content w-clearfix">
          <div className="top_title_nav profile w-clearfix">
            <h1 className="top_title">ביקרו בפרופיל שלי</h1>
          </div>
        </div>
      </div>

      <div className="content_sec desk wf-section">
        {membersCarpet === null ? (
          <BounakirCarpetLoader />
        ) : membersCarpet.length > 0 ? (
          <ul
            className="gallery_list prof w-list-unstyled"
            style={{ justifyContent: "flex-start" }}
          >
            {membersCarpet?.map((member, key): any => {
              console.log({ member });
              console.log({ key });
              console.log("selected.value: ", selected.value);

              return (
                <BounakirItem
                  key={member.memberCode}
                  member={member}
                  selected={selected.value}
                  canShowProfilePicture={canMemberWatchProfile(key)}
                  memberSendStickerToReciver={member.isSendStickerToMember}
                  deleteFootPrint={() => deleteFootPrint(member.memberCode)}
                />
              );
            })}
          </ul>
        ) : (
          <EmptyCarpetPlaceHolder
            imgSrc={"/assets/images/no_pict.png"}
            title={generateTitle()}
            subTitle={generateSubTitle()}
          />
        )}

        {/* {
                    selected.value === BounakirFilterType.BOUNAKIR_NEMU
                        ? <BounakirMenu />
                        : membersCarpet === null ?
                            <BounakirCarpetLoader />
                            : membersCarpet.length > 0 ?
                                <ul className="gallery_list prof w-list-unstyled" style={{ justifyContent: "flex-start" }}>
                                    {membersCarpet?.map((member, key): any => {

                                        return (
                                            <BounakirItem key={member.memberCode}
                                                member={member} selected={selected.value}
                                                canShowProfilePicture={canMemberWatchProfile(key)}
                                                memberSendStickerToReciver={member.isSendStickerToMember}
                                                deleteFootPrint={() => deleteFootPrint(member.memberCode)}
                                            />
                                        )
                                    })}
                                </ul>
                                :
                                <EmptyCarpetPlaceHolder
                                    imgSrc={"/assets/images/no_pict.png"}
                                    title={generateTitle()}
                                    subTitle={generateSubTitle()}
                                />
                } */}
      </div>
    </>
  );
};

export default BounakirWatchMeCarpet;
